import React from 'react';
import { Icon } from '@/components/global/Icons';
import { IMotorhomeTabs, IMotorhomeTabsTitles } from '../MotorhomeDetails';

enum ExcessReductionCoverNames {
    Basic = 'Risk Taker',
    Standard = 'Essentials',
    Full = 'Comprehensive',
}

export const MotorhomeExcessReductionTabPanel = ({ tab }: { tab: IMotorhomeTabs }) => {
    if (tab.title !== IMotorhomeTabsTitles.ExcessReduction || !tab?.excessReductionTable) {
        return;
    }
    return (
        <div id={tab.name} title={tab.title} className="flex justify-center pt-4">
            <div className="leading-4 inline-block max-w-full">
                <div role="region" tabIndex={0} className="overflow-auto snap-mandatory">
                    <table className="border-collapse" role="table">
                        <thead className="relative z-[10]" role="rowgroup">
                            <tr role="row">
                                <th role="columnheader" className="left-0 z-[10] border-l-0 box-border bg-clip-padding snap-start p-8 sticky top-0 border-t-0"></th>
                                {Object.values(ExcessReductionCoverNames).map((excessReductionName) => {
                                    return (
                                        <th
                                            key={excessReductionName}
                                            role="columnheader"
                                            className="h4 uppercase box-border snap-start px-2 md:px-6 lg:px-12 3xl:px-20 w-1/4 text-center whitespace-nowrap sticky top-0"
                                        >
                                            {excessReductionName}
                                        </th>
                                    );
                                })}
                            </tr>
                        </thead>
                        {tab?.excessReductionTable.excessReductionFeatures.map((item) => {
                            return (
                                <tbody className="odd:bg-shell even:bg-shell-50 relative h6" role="rowgroup" key={item.name}>
                                    <tr role="row" className="font-bold">
                                        <th
                                            role="cell"
                                            className="box-border bg-clip-padding snap-start pr-6 py-4 uppercase text-right sticky left-0 z-[10] bg-shell-25 border-r-2 border-shell"
                                        >
                                            {item.name && item.name.split('<small>')[0]}
                                            {item.name?.includes('<small>') && (
                                                <div className="text-[0.5rem] lg:text-[0.65rem] leading-[1]">
                                                    <small>{item.name.split('<small>')[1]?.replace('</small>', '')}</small>
                                                </div>
                                            )}
                                        </th>
                                        {[item.basic, item.standard, item.full].map((value, index) => (
                                            <td role="cell" className="box-border bg-clip-padding snap-start p-2.5 h-9 text-center z-1" key={index}>
                                                {(() => {
                                                    switch (item.type) {
                                                        case 'text':
                                                            return value;
                                                        case 'boolean':
                                                            return value ? (
                                                                <Icon id="tick" aria-label="tick" className="w-6 h-6 fill-primary mx-auto" />
                                                            ) : (
                                                                <Icon id="cross" aria-label="cross" className="w-5 h-5 fill-primary mx-auto" />
                                                            );
                                                    }
                                                })()}
                                            </td>
                                        ))}
                                    </tr>
                                </tbody>
                            );
                        })}
                    </table>
                </div>
            </div>
        </div>
    );
};
